import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import useNavigation from '@hooks/useNavigation.tsx';

/**
 * @deprecated Legacy new-expedition page. Anyone landing here is redirected to the new create flow.
 */
const NewExpeditionPage = () => {
  const nav = useNavigation();

  return <Navigate to={nav.createNavigationLink(nav.urlFunctions.createExpedition())} replace />;
};

export default withAuthenticationRequired(NewExpeditionPage);